import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MyCalendarComponent } from './calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';

@NgModule({
	imports: [
        FullCalendarModule,
        CommonModule,
        FormsModule
    ],
    declarations: [MyCalendarComponent],
    exports: [MyCalendarComponent],
    providers: []
})

export class  MyCalendarModule {}
